// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__GMKLI","version":"Footer_version__GXavo"};